import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ReferenceParams, Res } from 'src/app/models';
import { LanguageService, NotificationService, ValidatorsService } from 'src/app/services';
import { ApiPresetsService } from 'src/app/services/api-presets.service';
import { PresetValidator } from '../preset-create/preset-create.validators';

@Component({
  selector: 'app-preset-element-edit',
  templateUrl: './preset-element-edit.component.html',
  styleUrls: ['./preset-element-edit.component.css']
})
export class PresetElementEditComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  attributes: any[] = [];
  attributeGroups: any[] = [];
  attributeValueTypes: any[] = [];
  attributePresentationTypes: any[] = [];
  presetId:any;
  presets:any;

  form: UntypedFormGroup = this.fb.group({
    id:                           [null],
    is_default:                   [false],
    attribute_group_id:           [null, this.validator.attribute_group_id],
    attribute_id:                 [null, this.validator.attribute_id],
    attribute_value_type:         [null, this.validator.attribute_value_type],
    attr_group_order_num:         [null],
    attr_order_num:               [null],
    attr_present_type_id:         [null, this.validator.attr_present_type_id],
    selectors:                    [null],
    front_field_attrs:            [null],
    autocomplete_func:            [null],
    attr_value_mask:              [null],
    attr_value_mask_err_message:  [null],
    attribute_preset_value:       [null],
    attribute_preset_value_type:  [null],
    attribute_values_max_count:   [null],
    mandatory:                    [false],
    visible:                      [false],
    readonly:                     [false],
    translation:                  [false]
  });

  constructor(
    public ngProgress: NgProgress,
    private fb: UntypedFormBuilder,
    private languageService: LanguageService,
    private apiPresets: ApiPresetsService,
    private notification: NotificationService,
    private currentRoute: ActivatedRoute,
    private validator: PresetValidator,
    private validatorService: ValidatorsService

  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.presetId = this.currentRoute.snapshot.paramMap.get('id');

    this.onEdit();
    this.getAttributes();
    this.getAttributeGroup();
    this.getAttributeTypes();
    this.getAttributePresentationTypes();


    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );
  }

  ngDestroy() {
    this.subscriptions.unsubscribe();
  }

  /**
  * 
  */
  getAttributes(): void {

    let params: ReferenceParams = {
      ref_name: 'attributes',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributeGroup(): void {

    let params: ReferenceParams = {
      ref_name: 'attribute_groups',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeGroups = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributeTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_value_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributeValueTypes = response.result;
        }
      })
    );

  }

  /**
   * 
   */
  getAttributePresentationTypes(): void {

    let params: ReferenceParams = {
      ref_name: 'attrs_presentation_types',
      filter: {
      }
    }

    this.subscriptions.add(
      this.apiPresets.getReferences(params, params.ref_name).subscribe((response: any) => {

        if (response != null) {

          this.attributePresentationTypes = response.result;
        }
      })
    );

  }


   /**
    * 
    */
   onEdit(): void {

    this.progressRef.start();
    this.loading = true;

    this.subscriptions.add(

      this.apiPresets.edit(this.presetId).subscribe((response: Res) => {
        console.log('[RESPONSE] PRESET_EDIT: ', response);

        if (response != null) {

          this.presets = { ...response.result };

          this.setDataInForm(response.result);
        }
        this.progressRef.complete();
        this.loading = false;
      },
        error => {
          this.progressRef.complete();
          this.loading = false;
        })
    );
  }

  /**f
   * 
   */
   setDataInForm(data: any): any {

    this.form.controls.id.setValue(data.id);
    this.form.controls.attr_group_order_num.setValue(data.attr_group_order_num);
    this.form.controls.attr_order_num.setValue(data.attr_order_num);
    this.form.controls.attribute_id.setValue(data.attribute_id);
    this.form.controls.attr_present_type_id.setValue(data.attr_present_type_id);
    this.form.controls.attribute_group_id.setValue(data.attribute_group_id);
    this.form.controls.attribute_preset_value.setValue(data.attribute_preset_value);
    this.form.controls.attribute_preset_value_type.setValue(data.attribute_preset_value_type);
    this.form.controls.attribute_value_type.setValue(data.attribute_value_type);
    this.form.controls.attribute_values_max_count.setValue(data.attribute_values_max_count);
    this.form.controls.autocomplete_func.setValue(data.autocomplete_func);
    this.form.controls.front_field_attrs.setValue(data.front_field_attrs);
    this.form.controls.is_default.setValue(data.is_default);
    this.form.controls.mandatory.setValue(data.mandatory);
    this.form.controls.readonly.setValue(data.readonly);
    this.form.controls.selectors.setValue(data.selectors);
    this.form.controls.translation.setValue(data.translation);
    this.form.controls.visible.setValue(data.visible);
  }

  /**
   * 
   */
  onUpdate() {

    let form = { ...this.form.value }

    this.progressRef.start();

    this.subscriptions.add(
      this.apiPresets.update(form).subscribe((response: Res) => {
        console.log('[RESPONSE] UPDATE PRESET INFO: ', response);

        if (response != null) {

          this.onEdit();
          this.notification.show('success', 'Данные успешно сохранены!');
        }

        this.progressRef.complete();
      },
        error => {
          this.progressRef.complete();
        })
    );
  }

  /**
   * 
   * @param field 
   * @param type 
   */
   validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.form.get(field), type);
  }
}
